import * as React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line no-restricted-imports
import { spaces } from '@99designs/emu/settings';
import { DisplayName } from '@99designs/frontend-components/components/DisplayName';
import { UserAvatar } from '@99designs/users';
import AvatarCollection from './AvatarCollection';
import { Designer } from './User';

interface Props {
    users: Designer[];
}

const StyledHeaderUserLayout = styled.div`
    display: flex;
`;

const Label = styled.div`
    margin: auto ${spaces['0.25bu']} auto 0px;
`;

const DesignerName = styled.div`
    text-align: left;
    margin: auto ${spaces['0.25bu']};
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const HeaderUserLayout = ({ users }: Props) => (
    <StyledHeaderUserLayout data-testid="header-user-layout">
        <Label>{__('with')}</Label>
        {users.length === 1 ? (
            <UserAvatar userId={users[0].id} size="small" border />
        ) : (
            <AvatarCollection users={users} size={'small'} limit={7} />
        )}
        <DesignerName>
            {users.length === 1 && (
                <DisplayName
                    user={{
                        name: users[0].displayName,
                        profileUrl: `/profiles/${users[0].id}`,
                    }}
                    isLinked={false}
                />
            )}
        </DesignerName>
    </StyledHeaderUserLayout>
);

export default HeaderUserLayout;
